import Vue from 'vue'

const STORAGE_KEY = 'lsfp-locale'
const DEFAULT_LOCALE = 'zh-Hant'

function readStoredLocale() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || DEFAULT_LOCALE
  } catch (error) {
    return DEFAULT_LOCALE
  }
}

function writeStoredLocale(locale) {
  try {
    window.localStorage.setItem(STORAGE_KEY, locale)
  } catch (error) {
    // Ignore storage failures so language switching never blocks page rendering.
  }
}

export const languageState = Vue.observable({
  locale: readStoredLocale()
})

export const LANGUAGES = [
  { label: '繁', value: 'zh-Hant', icon: '繁' },
  { label: '英', value: 'en', icon: 'EN' }
]

const EN = {
  '首頁': 'Home',
  '生態體系': 'Ecosystem',
  '合作夥伴': 'Partners',
  '關於我們': 'About Us',
  '聯繫我們': 'Contact Us',
  '連接體育 · 連接文化': 'Connecting Sports · Connecting Culture',
  '連接價值 · 連接未來': 'Connecting Value · Connecting The Future',
  '隱私政策': 'Privacy Policy',
  '服務條款': 'Terms of Service',
  '風險提示': 'Risk Notice',
  '生態概覽': 'Ecosystem Overview',
  '產品體系': 'Product System',
  '通證經濟': 'Token Economy',
  '商戶合作': 'Merchant Partnership',
  '品牌合作': 'Brand Partnership',
  '生態夥伴': 'Ecosystem Partners',
  '項目介紹': 'Project Overview',
  '團隊介紹': 'Team Overview',
  '合規與安全': 'Compliance & Security',
  '關注我們': 'Follow Us',
  '加入社群': 'Join Community',
  '訂閱郵件': 'Subscribe',
  '連接錢包': 'Connect Wallet',
  '選單': 'Menu',
  '關閉選單': 'Close Menu',
  '切換語言': 'Switch Language',
  '資料即將開放': 'Materials will be available soon',
  '錢包連接功能即將開放': 'Wallet connection will be available soon',

  '真實場景、憑證化入口': 'Real Scenarios, Credentialized Access',
  '與可驗證增長閉環': 'And A Verifiable Growth Loop',
  '澳門體育文旅場景轉化邏輯': 'Macau Sports & Travel Scenario Conversion Logic',
  '從活動參與、文旅消費到權益核銷與會員沉澱，構建可驗證、可持續的 Web3 體育文旅增長方式。': 'From event participation and travel consumption to benefit redemption and member retention, LSFP builds a verifiable and sustainable Web3 growth model for sports and travel.',
  '探索生態': 'Explore Ecosystem',
  '下載白皮書': 'Download Whitepaper',
  '七層價值閉環': 'Seven-Layer Value Loop',
  '持續成長閉環': 'Continuous Growth Loop',
  '核心產品體系': 'Core Product System',
  'LOTUS 通證用途': 'LOTUS Token Utility',
  '增長數據與價值': 'Growth Data & Value',
  '加入蓮花生態，共創體育文旅新未來': 'Join The Lotus Ecosystem And Build The Future Of Sports Travel',
  '從真實參與、到價值會員、從權益消費、到鏈上確權': 'From real participation to valuable members, from benefit consumption to on-chain ownership.',
  '聯繫我們 →': 'Contact Us →',
  '憑證入口': 'Credential Access',
  '會員沉澱': 'Member Retention',
  '可驗證增長': 'Verifiable Growth',
  '賽事票務與活動憑證': 'Event tickets and activity credentials',
  '好運權重': 'Luck Power',
  'Luck Power 激勵體系': 'Luck Power incentive system',
  'LOTUS 經濟引擎': 'LOTUS Economy Engine',
  '生態權益、支付與治理': 'Ecosystem benefits, payment and governance',
  '權益核銷與真實消費': 'Benefit Redemption & Real Consumption',
  '線上權益與線下履約': 'Online benefits and offline fulfillment',
  '收入引擎': 'Revenue Engine',
  '商戶、品牌、活動多元收益': 'Multi-source revenue from merchants, brands and events',
  '生態網絡與價值複利': 'Ecosystem Network & Value Compounding',
  '合作夥伴持續增長': 'Sustained partner growth',
  '會員身份、等級、權益與成長': 'Membership identity, levels, benefits and growth',
  '賽事參與數字憑證入口': 'Digital credential entry for sports participation',
  '行為貢獻和權益權重': 'Behavior contribution and benefit weighting',
  '獎勵池與活動激勵': 'Reward pools and activity incentives',
  '商家權益與消費核銷': 'Merchant benefits and consumption redemption',
  '會員展開': 'Membership Expansion',
  '會員身份成長與等級權益': 'Membership growth and tier benefits',
  '權益支付': 'Benefit Payment',
  '權益領取、兌換與消費核銷': 'Benefit claiming, exchange and redemption',
  '通證准入': 'Token Access',
  '活動資格與會員准入': 'Event qualification and member access',
  '用戶權益增強': 'User Benefit Enhancement',
  '權重提升與優先權益': 'Weight increase and priority benefits',
  '生態獎勵池': 'Ecosystem Reward Pool',
  '活動獎勵與生態激勵': 'Event rewards and ecosystem incentives',
  '真實場景入口': 'Real Scenario Entries',
  '覆蓋賽事及澳門文旅消費': 'Covering events and Macau travel consumption',
  '合作夥伴': 'Partners',
  '權益、商戶與活動資源': 'Benefits, merchants and event resources',
  '10億+': '1B+',
  'LOTUS 總發行量': 'Total LOTUS Supply',
  '生態價值承載': 'Ecosystem value carrier',
  '可驗證': 'Verifiable',
  '鏈上憑證機制': 'On-chain credential mechanism',
  '權益核銷與行為記錄': 'Benefit redemption and behavior records',
  '可複投': 'Reinvestable',
  '用戶增長結構': 'User growth structure',
  '任務、權益與會員留存': 'Tasks, benefits and member retention',
  '可持續': 'Sustainable',
  '生態商業閉環': 'Ecosystem business loop',
  '收入、獎勵與治理協同': 'Revenue, rewards and governance synergy',

  '將真實參與轉化為真實價值': 'Turning Real Participation Into Real Value',
  '為什麼LSFP與眾不同': 'Why LSFP Is Different',
  '真實場景探索': 'Real scenario discovery',
  '身份驗證': 'Identity verification',
  '場景導入': 'Scenario onboarding',
  '參與紀錄': 'Participation records',
  '真實權益兌換': 'Real benefit redemption',
  '用戶到店': 'Store visits',
  '積分兌換': 'Point redemption',
  '禮品投放': 'Gift distribution',
  '真實營收收入': 'Real revenue income',
  '用戶增長': 'User growth',
  '流量變現': 'Traffic monetization',
  '生態收益': 'Ecosystem revenue',
  '六大真實入口網絡': 'Six Real Entry Networks',
  '體育賽事': 'Sports Events',
  '文旅景區': 'Travel Attractions',
  '演藝活動': 'Entertainment Events',
  '運動健康': 'Sports & Wellness',
  '媒體娛樂': 'Media & Entertainment',
  '消費權益': 'Consumer Benefits',
  '會員通行證設施': 'Membership Pass Infrastructure',
  '會員特權': 'Member Privileges',
  '等級沉澱': 'Tier accumulation',
  '優先參與': 'Priority access',
  '商戶優惠': 'Merchant Offers',
  '折扣禮遇': 'Discount benefits',
  '活動權益': 'Event Benefits',
  '限定禮品': 'Limited gifts',
  '專屬任務': 'Exclusive Tasks',
  '完成任務': 'Complete tasks',
  '解鎖獎勵': 'Unlock rewards',
  '累積體系': 'Accumulation System',
  '等級提升': 'Tier upgrades',
  '專屬徽章': 'Exclusive badges',
  '好運權重體系': 'Luck Power Weighting System',
  '權重來源': 'Weight Sources',
  '登錄記錄': 'Login Records',
  '遊蹤成長': 'Journey Growth',
  '參與賽事': 'Event Participation',
  '用戶消費': 'User Consumption',
  '生態貢獻': 'Ecosystem Contribution',
  'LOTUS 質押': 'LOTUS Staking',
  '權重用途': 'Weight Uses',
  '活動優先權': 'Event Priority',
  '免費折扣權益': 'Free Discount Benefits',
  '稀缺權益倍增': 'Rare Benefit Multiplier',
  '合作機構優先': 'Partner Priority',
  '專屬禮包權益': 'Exclusive Gift Packs',
  '權重明細': 'Weight Details',
  '行為確實': 'Verified Behavior',
  '防機器人': 'Anti-bot',
  '參與時長': 'Participation Duration',
  '防刷量': 'Anti-farming',
  '防虛假行為': 'Anti-fraud',
  '權重評估': 'Weight Evaluation',
  '生態護城河': 'Ecosystem Moat',
  '真實用戶資產': 'Real User Assets',
  'KYC、場景驗證和價值沉澱': 'KYC, scenario verification and value accumulation',
  '高頻入口護城河': 'High-Frequency Entry Moat',
  '六大入口轉化，形成生態閉環': 'Six entry conversions forming an ecosystem loop',
  '通證經濟飛輪': 'Token Economy Flywheel',
  'Burn、Pass 2.0、價值回流': 'Burn, Pass 2.0 and value return',
  '生態協同效應': 'Ecosystem Synergy',
  '跨行業連接，放大網絡效應': 'Cross-industry connections amplifying network effects',
  '數據資產價值': 'Data Asset Value',
  '用戶行為沉澱，驅動精準運營': 'User behavior data drives precise operations',
  '增長飛輪': 'Growth Flywheel',
  '真實入口': 'Real Entry',
  '真實通證化': 'Real Tokenization',
  '真實參與': 'Real Participation',
  '真實收益': 'Real Revenue',
  '真實人數': 'Real Users',
  'Active 用戶增長': 'Active user growth',
  'Pass / NFT 權益': 'Pass / NFT benefits',
  '用戶權重提升': 'User weight growth',
  'LOTUS 需求': 'LOTUS Demand',
  '價值循環': 'Value cycle',
  '權益兌換': 'Benefit Redemption',
  '高頻消費兌換': 'High-frequency consumption redemption',
  '商戶收益': 'Merchant Revenue',
  '收益入帳': 'Revenue booking',
  '生態增長': 'Ecosystem Growth',
  '反哺平台': 'Reinvest into the platform',
  '透明生態': 'Transparent Ecosystem',
  '真實用戶數': 'Real Users',
  '持續增長中': 'Continuously growing',
  '生態參與數': 'Ecosystem Participation',
  '持續沉澱': 'Continuously accumulating',
  '合作夥伴數': 'Partners',
  '全球佈局': 'Global Presence',
  '生態交易額': 'Ecosystem Transaction Volume',
  '多重管理': 'Multi-signature management',
  '資金池': 'Treasury Pool',
  '審計準備': 'Audit ready',
  '鏈上驗證': 'On-chain verification',
  '未來願景': 'Future Vision',
  '從現在啟航的': 'A sports travel',
  '體育文旅生態': 'ecosystem starting now',
  '澳門': 'Macau',
  '從澳門出發的體育文旅生態': 'A sports travel ecosystem starting from Macau',
  '大灣區': 'Greater Bay Area',
  '打通跨境文旅會員網絡': 'Connecting cross-border travel membership networks',
  '亞洲': 'Asia',
  '拓展更多國際合作場景': 'Expanding more international cooperation scenarios',
  '全球網絡': 'Global Network',
  '共建下一代會員經濟': 'Building the next-generation membership economy',
  '共建下一代會員經濟網絡': 'Building the next-generation membership economy network',
  '打造全球領先 Web3 體育文旅生態': 'Building A Global Leading Web3 Sports Travel Ecosystem',
  '連接體育、文旅、公益、品牌、用戶，共創勝利的未來': 'Connecting sports, travel, public good, brands and users to create a winning future.',

  '全球首個體育好運會員通證生態': 'The world’s first sports luck membership token ecosystem',
  'LSFP 以真實體育與文旅場景為入口，融合 Web3 數字憑證、會員體系、通證經濟 與線下權益，打造可持續、可驗證、可增益的體育文旅新生態。': 'LSFP uses real sports and cultural travel scenarios as its entry point, integrating Web3 digital credentials, membership systems, token economics and offline benefits to build a sustainable, verifiable and value-enhancing sports travel ecosystem.',
  'LSFP 以真實體育與文旅場景為入口，融合 Web3 數字憑證、會員體系、通證經濟': 'LSFP uses real sports and cultural travel scenarios as its entry point, integrating Web3 digital credentials, membership systems and token economics',
  '與線下權益，打造可持續、可驗證、可增益的體育文旅新生態。': 'with offline benefits to build a sustainable, verifiable and value-enhancing sports travel ecosystem.',
  '全球粉絲基數': 'Global Fan Base',
  '龐大文化與體育受眾': 'Large cultural and sports audience',
  '100 億': '10B',
  '固定總量，永不增發': 'Fixed supply, no additional issuance',
  '501 席': '501 Seats',
  '全球主持有席位': 'Global Master Seats',
  '三重守護，稀缺註冊權益': 'Triple protection with scarce registration rights',
  'RWA 賦能': 'RWA Empowerment',
  '真實資產支持': 'Real Asset Support',
  '線下通證，法幣與文旅權益合規': 'Offline token, fiat and travel benefits compliance',
  '暴力通縮': 'Aggressive Deflation',
  '持續回購銷毀': 'Continuous Buyback & Burn',
  '驅動價值穩步上升': 'Driving steady value growth',
  '我們的使命與願景': 'Our Mission & Vision',
  '我們的核心價值觀': 'Our Core Values',
  '我們的核心優勢': 'Our Advantages',
  '我們的使命': 'Our Mission',
  '通過體育、文化與科技融合體驗，連接全球用戶、賦予品牌、俱樂部、球員、可持續的體育文旅價值生態，推動公益慈善與文化傳播。': 'Through integrated sports, culture and technology experiences, LSFP connects global users and empowers brands, clubs and athletes with a sustainable sports travel value ecosystem.',
  '我們的願景': 'Our Vision',
  '成為全球領先的體育文旅數字生態平台，讓球迷、健身及文化連接世界，讓每一次參與都產生長期價值。': 'To become a global leading digital ecosystem for sports and travel, connecting fans, fitness and culture with the world, and making every participation create long-term value.',
  '真實': 'Real',
  '真實場景': 'Real Scenarios',
  '真實價值': 'Real Value',
  '透明': 'Transparent',
  '公開機制': 'Open Mechanism',
  '鏈上可查': 'On-chain Traceable',
  '共贏': 'Win-Win',
  '用使命': 'Mission driven',
  '用戶與平台共贏': 'Users and platform win together',
  '創新': 'Innovation',
  '技術驅動': 'Technology driven',
  '體驗創新': 'Experience innovation',
  '公益': 'Public Good',
  '體育公益': 'Sports public good',
  '反哺社會': 'Giving back to society',
  '真實場景護城河': 'Real Scenario Moat',
  '深度整合體育賽事、俱樂部、文旅、娛樂活動、城市運動、明星 IP 與品牌商戶，構建真實場景的流量入口與權益生態。': 'Deeply integrating sports events, clubs, travel, entertainment, city sports, celebrity IP and merchants to build real traffic entries and benefit ecosystems.',
  '憑證化入口體系': 'Credentialized Entry System',
  '獨創 Sports Ticket NFT、Voucher NFT 憑證化體系，鎖定線下真實行為與會員憑證，可追溯的數字資產。': 'An original Sports Ticket NFT and Voucher NFT credential system that anchors real offline behavior and membership credentials as traceable digital assets.',
  '會員沉澱與成長': 'Member Retention & Growth',
  'Lotus Sports Pass 會員體系，結合 Luck Power 權益體系，激勵用戶長期參與與成長，提升黏性與活躍度。': 'Lotus Sports Pass combines with Luck Power to motivate long-term participation and growth, improving loyalty and activity.',
  '通證經濟模型': 'Token Economy Model',
  'LOTUS 通證具有多元用途與強需求支撐，結合回購銷毀、節點激勵與通證銷毀，驅動長期價值增長。': 'LOTUS has multiple uses and strong demand support, combining buyback, burn and node incentives to drive long-term value growth.',
  '權益商城與核銷': 'Rewards Marketplace & Redemption',
  '豐富的 Sports & Travel Rewards Marketplace，覆蓋交通、酒店、餐飲、賽事、康養、數旅等多維權益，支持線下真實核銷。': 'A rich Sports & Travel Rewards Marketplace covering transport, hotels, dining, events, wellness and digital travel benefits with real offline redemption.',
  '商業閉環與復投': 'Business Loop & Reinvestment',
  '商戶營銷閉環、核銷轉化、數據沉澱與持續復投，構建 B 端商業飛輪，保障生態收入與通證價值穩健增長。': 'Merchant marketing loops, redemption conversion, data accumulation and continuous reinvestment form a B-side business flywheel.',
  '好運 · 體育 · 未來': 'Luck · Sports · Future',
  '連接體育 · 連接文化 · 連接價值 · 連接未來': 'Connecting Sports · Culture · Value · The Future',
  '加入 LSFP，共建體育文旅數字未來新生態！': 'Join LSFP and build the new digital future of sports travel.',
  '立即加入生態': 'Join The Ecosystem',

  '共建下一代體育文旅會員經濟': 'Building the next-generation sports travel membership economy',
  '連接體育、旅遊、遊戲及周邊，品牌與IP的安全合規網絡，構建真實用戶、真實消費與真實增長生態閉環。': 'Connecting sports, travel, games and related industries through a secure and compliant brand and IP network, building a loop of real users, consumption and growth.',
  '成為合作夥伴': 'Become A Partner',
  '合作成果案例': 'Success Stories',
  '追擇LSFP的四大理由': 'Four Reasons To Choose LSFP',
  '真實用戶入口': 'Real User Entry',
  '來自體育、文旅、社交、商品及線下的真實流量': 'Real traffic from sports, travel, social, merchandise and offline scenarios',
  '長期會員資產': 'Long-Term Member Assets',
  '不是一次性觸達，而是可運營的長效會員': 'Not one-off reach, but long-term operable members',
  '真實核銷網絡': 'Real Redemption Network',
  '線上權益、線下消費，真實履約可驗證': 'Online benefits and offline consumption with verifiable fulfillment',
  '真實收入增長': 'Real Revenue Growth',
  '會員增長、交易轉化、商戶聯動，持續增長': 'Member growth, transaction conversion and merchant collaboration drive continuous growth',
  'LSFP 獨有優勢': 'LSFP Unique Advantages',
  '澳門體育文旅入口': 'Macau Sports Travel Gateway',
  '承接官方流量，聯結澳門及大灣區資源': 'Receiving official traffic and connecting Macau and Greater Bay Area resources',
  '真實賽事網絡': 'Real Sports Event Network',
  '官方賽事資源合作，提升曝光及用戶粘性': 'Official event cooperation improves exposure and user stickiness',
  '會員體系沉澱': 'Membership Layer Accumulation',
  'Lotus Sports Pass 承接長期會員資產': 'Lotus Sports Pass carries long-term member assets',
  '真實核銷體系': 'Real Redemption System',
  '線上線下權益閉環，保障真實消費履約': 'Online-offline benefit loops ensure real consumption fulfillment',
  '數據資產沉澱': 'Data Asset Accumulation',
  '用戶行為數據沉澱，驅動精準運營決策': 'User behavior data supports precise operational decisions',
  '生態價值賦能': 'Ecosystem Value Enablement',
  'LOTUS 認證生態，共享增長價值': 'LOTUS-certified ecosystem sharing growth value',
  '構建難以複製的生態能力': 'Building ecosystem capabilities that are difficult to replicate',
  '針對不同飲伴的合作方案': 'Solutions For Different Partner Types',
  '瞭解更多 →': 'Learn More →',
  '您將獲得': 'What You Get',
  '增長如何轉化為收益': 'How Growth Converts Into Revenue',
  '用戶轉化率': 'User Conversion Rate',
  '復購率提升': 'Repeat Purchase Increase',
  '會員復購率': 'Member Repeat Purchase Rate',
  '收益 ROI': 'Revenue ROI',
  '合作增長飛輪生態的同，持續增長每位夥伴共享生態價值': 'Partner growth flywheel where every partner shares ecosystem value',
  '高階合作': 'Advanced Partnership',
  '共贏增長': 'Win-Win Growth',
  '收入增長': 'Revenue Growth',
  '持續收益': 'Sustained Revenue',
  '權益折扣': 'Benefit Discounts',
  '線下消費': 'Offline Consumption',
  '合作夥伴加入': 'Partners Join',
  '生態網絡': 'Ecosystem Network',
  '權益配置': 'Benefit Allocation',
  '定製化方案': 'Customized Solutions',
  '活動上線': 'Event Launch',
  '聯合運營推廣': 'Joint Operations',
  '每位夥伴都參與增長，共享生態價值。': 'Every partner participates in growth and shares ecosystem value.',
  '立即成為合作夥伴 →': 'Become A Partner Now →',
  '生態規綢與數據': 'Ecosystem Scale & Data',
  '查看全球合作網絡 →': 'View Global Partner Network →',
  '加入蓬花生態網絡': 'Join The Lotus Ecosystem Network',
  '企業名稱': 'Company Name',
  '請輸入企業名稱': 'Enter company name',
  '聯繫人': 'Contact Person',
  '請輸入聯繫人姓名': 'Enter contact name',
  '合作類型': 'Partnership Type',
  '請選擇合作類型': 'Select partnership type',
  '聯繫方式': 'Contact',
  '手機號或郵箱': 'Phone or email',
  '我已閱讀並同意《合作夥伴協議》和《隱私政策》': 'I have read and agree to the Partner Agreement and Privacy Policy',
  '提交中...': 'Submitting...',
  '提交申請': 'Submit Application',
  '下一步': 'Next Steps',
  '填寫表單與提交申請': 'Fill in the form and submit application',
  '定製化合作方案溝通': 'Discuss customized partnership plan',
  '合作落地與資源對接': 'Implement partnership and connect resources',
  '啟動運營與持續增長': 'Launch operations and continue growth',
  '查看申請狀態': 'View Application Status',
  '下載合作手冊': 'Download Partnership Deck',
  '合作品牌': 'Partner Brands',
  '商戶聯盟': 'Merchant Alliance',
  '體育 IP': 'Sports IP',
  '目標會員': 'Target Members',
  '澳門綜合度假村': 'Macau Integrated Resort',
  '體育賽事系列': 'Sports Event Series',
  '品牌聯名系列': 'Brand Collaboration Series',
  '商戶合作案例': 'Merchant Partnership Case',
  '合作增長': 'Partnership Growth',
  '新增會員': 'New Members',
  '復購提升': 'Repeat Purchase Lift',
  '參與選手': 'Participants',
  'NFT到店會員': 'NFT Store Members',
  '會員轉化': 'Member Conversion',
  '曝光量': 'Impressions',
  '活躍ROI': 'Active ROI',
  '復購率': 'Repeat Purchase Rate',
  '促銷核銷': 'Promotion Redemptions',
  '消費增長': 'Consumption Growth',
  '用戶留存': 'User Retention',
  '賽事合作方案': 'Sports event partnership plan',
  '文旅合作方案': 'Travel partnership plan',
  '品牌聯合方案': 'Brand co-marketing plan',
  '商戶聯盟方案': 'Merchant alliance plan',
  '體育 IP 合作方案': 'Sports IP partnership plan',
  '用戶參與': 'User Participation',
  '獲取流量': 'Acquire Traffic',
  '轉化會員': 'Convert Members',
  '提升活躍': 'Increase Activity',
  '到店核銷': 'Store Redemption',
  '產生收益': 'Generate Revenue',
  '復購增長': 'Repeat Purchase Growth',
  '提升 ROI': 'Increase ROI',
  '會員總數': 'Total Members',
  '活動數量': 'Number Of Events',
  '權益核銷次數': 'Benefit Redemptions',
  '生態收入': 'Ecosystem Revenue',
  '4 億+': '400M+',
  '戰略合作夥伴': 'Strategic Partner',
  '品牌合作夥伴': 'Brand Partner',
  '商戶合作夥伴': 'Merchant Partner',
  '戰略合作伙伴': 'Strategic Partner',
  '品牌合作伙伴': 'Brand Partner',
  '商戶合作伙伴': 'Merchant Partner',
  '體育賽事合作': 'Sports Event Partnership',
  '文旅資源合作': 'Travel Resource Partnership',
  '品牌聯合合作': 'Brand Co-Marketing',
  '商戶權益合作': 'Merchant Benefit Partnership',
  '體育 IP 合作': 'Sports IP Partnership',
  '流量增長': 'Traffic Growth',
  '高質量體育用戶導入': 'High-quality sports user acquisition',
  '賽事參與轉化留存': 'Event participation conversion and retention',
  '品牌曝光': 'Brand Exposure',
  '全鏈路品牌曝光': 'Full-funnel brand exposure',
  '收入分成': 'Revenue Share',
  '活動收益分成合作': 'Event revenue-sharing partnership',
  '申請已提交，我們會盡快聯繫您。': 'Application submitted. We will contact you soon.',
  '提交失敗，請稍後重試。': 'Submission failed. Please try again later.',

  '攜手共建體育文旅數字生態的未來': 'Build the future of the digital sports travel ecosystem together',
  '聯繫中心': 'Contact Center',
  '選擇您需要的服務，我們將為您提供專業支持': 'Select the service you need and we will provide professional support.',
  '請選擇您的需求': 'Choose Your Purpose',
  '服務承諾': 'Service Commitment',
  '專業 · 透明 · 高效': 'Professional · Transparent · Efficient',
  '全球佈局': 'Global Presence',
  '商務綠色通道': 'Business Fast Track',
  '常見問題': 'FAQ',
  '提交您的需求': 'Send Us A Message',
  '需求描述': 'Requirement Description',
  '請詳細描述您的合作需求': 'Describe your partnership needs in detail',
  '郵箱': 'Email',
  '請輸入郵箱地址': 'Enter email address',
  '請輸入聯繫人': 'Enter contact person',
  '上傳附件（可選）': 'Upload Attachment (Optional)',
  '支持 pdf / doc / ppt / jpg / png，最大 10MB': 'Supports pdf / doc / ppt / jpg / png, max 10MB',
  '再次上傳': 'Upload More',
  '上傳文件': 'Upload File',
  '重新上傳': 'Replace',
  '刪除圖片': 'Delete Image',
  '放大預覽': 'Zoom Preview',
  '提交需求': 'Submit Request',
  '準備加入 LSFP 生態了嗎？': 'Ready to join the LSFP ecosystem?',
  '成為合作伙伴': 'Become A Partner',
  '預約商務會議': 'Schedule A Meeting',
  '立即申請': 'Apply Now',
  '預計對接週期：': 'Estimated onboarding cycle: ',
  '澳門總部': 'Macau HQ',
  '香港': 'Hong Kong',
  '深圳': 'Shenzhen',
  '新加坡': 'Singapore',
  '迪拜': 'Dubai',
  '商務合作': 'Business Cooperation',
  '投資機構': 'Investors',
  '媒體合作': 'Media Cooperation',
  '技術支持': 'Technical Support',
  '用戶服務': 'User Service',
  'Web3 生態合作': 'Web3 Ecosystem Cooperation',
  '品牌合作': 'Brand Cooperation',
  '賽事合作': 'Event Cooperation',
  '戰略合作': 'Strategic Cooperation',
  '基金': 'Funds',
  '戰略資本': 'Strategic Capital',
  '媒體採訪': 'Media Interview',
  '新聞合作': 'News Cooperation',
  '品牌傳播': 'Brand Communication',
  '錢包問題': 'Wallet Issues',
  '帳戶問題': 'Account Issues',
  '系統問題': 'System Issues',
  '會員權益': 'Member Benefits',
  '活動參與': 'Activity Participation',
  '權益兌換': 'Benefit Exchange',
  '鏈': 'Chain',
  '交易所': 'Exchange',
  '公鏈': 'Public Chain',
  '生態項目': 'Ecosystem Project',
  '我是賽事方': 'I am an event organizer',
  '我是文旅機構': 'I am a travel institution',
  '我是品牌商戶': 'I am a brand merchant',
  '我是明星 IP': 'I am a celebrity IP',
  '我是 Web3 項目': 'I am a Web3 project',
  '我是投資機構': 'I am an investor',
  '我是普通用戶': 'I am a user',
  '7×24': '24/7',
  '5 分鐘': '5 Minutes',
  '24 小時': '24 Hours',
  '48 小時': '48 Hours',
  '在線服務': 'Online Service',
  '在線響應': 'Online Response',
  '在線客服響應': 'Online Support Response',
  '郵件回覆': 'Email Reply',
  '商務對接': 'Business Connection',
  '全球服務支持': 'Global Service Support',
  '5 分鐘在線響應': '5-minute online response',
  '24 小時郵件回覆': '24-hour email reply',
  '48 小時商務對接': '48-hour business connection',
  '7 x 24 全球服務': '24/7 global service',
  '戰略合作夥伴': 'Strategic Partner',
  '品牌合作夥伴': 'Brand Partner',
  '商戶合作夥伴': 'Merchant Partner',
  '深度戰略資源對接': 'Deep strategic resource connection',
  '聯合生態共建': 'Joint ecosystem co-building',
  '長期價值共享': 'Long-term value sharing',
  '品牌曝光與活動': 'Brand exposure and campaigns',
  '營銷資源支持': 'Marketing resource support',
  '流量增長轉化': 'Traffic growth conversion',
  '權益商城入駐': 'Rewards marketplace onboarding',
  '用戶權益引流': 'User benefit traffic acquisition',
  '銷售增長賦能': 'Sales growth enablement',
  '1-3 工作日': '1-3 business days',
  '2-3 工作日': '2-3 business days',
  '1-2 工作日': '1-2 business days',
  '預計對接週期：1-3 工作日': 'Estimated onboarding cycle: 1-3 business days',
  '預計對接週期：2-3 工作日': 'Estimated onboarding cycle: 2-3 business days',
  '預計對接週期：1-2 工作日': 'Estimated onboarding cycle: 1-2 business days',
  '活動共建': 'Event Co-creation',
  '品牌聯名': 'Brand Collaboration',
  '商戶入駐': 'Merchant Onboarding',
  '媒體採訪與內容合作': 'Media interviews and content cooperation',
  '節點 / 交易所 / 生態合作': 'Node / exchange / ecosystem cooperation',
  '如何申請合作？': 'How do I apply for partnership?',
  '多久可以獲得回覆？': 'How long does it take to get a reply?',
  '如何接入權益商城？': 'How do I access the rewards marketplace?',
  '如何成為生態夥伴？': 'How do I become an ecosystem partner?',
  '如何成為生態伙伴？': 'How do I become an ecosystem partner?',
  '如何參與 LOTUS 生態？': 'How do I participate in the LOTUS ecosystem?'
}

const originalTextNodes = new WeakMap()
let applying = false

export function setLocale(locale) {
  languageState.locale = locale || DEFAULT_LOCALE
  writeStoredLocale(languageState.locale)
  document.documentElement.lang = languageState.locale === 'en' ? 'en' : 'zh-Hant'
  translateDocument()
}

export function getLocale() {
  return languageState.locale
}

function translateValue(value) {
  const trimmed = value.trim()
  if (!trimmed) return value

  const translated = EN[trimmed]
  if (translated) return value.replace(trimmed, translated)

  const normalized = trimmed.replace(/\s+/g, ' ')
  const normalizedTranslated = EN[normalized]
  if (normalizedTranslated) return value.replace(trimmed, normalizedTranslated)

  if (trimmed.includes('\n')) {
    const translatedLines = trimmed
      .split(/(\r?\n)/)
      .map((part) => {
        if (/^\r?\n$/.test(part)) return part
        const line = part.trim()
        return line ? part.replace(line, EN[line] || line) : part
      })
      .join('')

    if (translatedLines !== trimmed) {
      return value.replace(trimmed, translatedLines)
    }
  }

  return value
}

function translateTextNode(node) {
  if (!originalTextNodes.has(node)) {
    originalTextNodes.set(node, node.nodeValue)
  }

  const original = originalTextNodes.get(node)
  node.nodeValue = languageState.locale === 'en' ? translateValue(original) : original
}

function translateAttributes(el) {
  const attrs = ['placeholder', 'aria-label', 'title', 'alt']

  attrs.forEach((name) => {
    if (!el.hasAttribute || !el.hasAttribute(name)) return

    const key = `data-i18n-original-${name}`
    if (!el.hasAttribute(key)) {
      el.setAttribute(key, el.getAttribute(name))
    }

    const original = el.getAttribute(key)
    el.setAttribute(name, languageState.locale === 'en' ? translateValue(original) : original)
  })
}

function shouldSkip(el) {
  if (!el || !el.tagName) return false
  const tag = el.tagName.toLowerCase()
  return tag === 'script' || tag === 'style' || tag === 'noscript'
}

function translateNode(root) {
  if (!root || shouldSkip(root)) return

  if (root.nodeType === Node.TEXT_NODE) {
    translateTextNode(root)
    return
  }

  if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return

  if (root.nodeType === Node.ELEMENT_NODE) {
    translateAttributes(root)
  }

  root.childNodes.forEach(child => translateNode(child))
}

export function translateDocument() {
  if (!document.body || applying) return

  applying = true
  translateNode(document.body)
  applying = false
}

export function installI18n(router) {
  document.documentElement.lang = languageState.locale === 'en' ? 'en' : 'zh-Hant'

  if (languageState.locale === 'en') {
    window.setTimeout(translateDocument, 0)
  }

  if (router) {
    router.afterEach(() => {
      if (languageState.locale === 'en') {
        Vue.nextTick(translateDocument)
      }
    })
  }
}

export function uninstallI18n() {
}
